import React from 'react';
import { EntityAskAI } from '../../common/EntityAskAI';

interface FolderAskAIProps {
  folderName: string;
  fileIds: string[];
  teamId: string;
}

const getSuggestions = () => [
  'What are in these recordings?',
  'Summarize all recordings',
  'What are the main topics?',
  'What action items were mentioned?',
  'Create a summary report',
];

export const FolderAskAI: React.FC<FolderAskAIProps> = ({
  folderName,
  fileIds,
  teamId,
}) => {
  return (
    <EntityAskAI
      entityName={folderName}
      entityType="person"
      fileIds={fileIds}
      teamId={teamId}
      getSuggestions={getSuggestions}
    />
  );
};

export default FolderAskAI;
